import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddServiceLevelModal from '../../containers/global-settings/AddServiceLevelModal'
import EditServiceLevelModal from './EditServiceLevelModal'
import RemoveServiceLevelModal from './RemoveServiceLevelModal'
import SettingList from './SettingList'
import { IMap, IProviderServiceLevel } from '../../types'
import BackToList from '../ui/BackToList'

interface IServiceLevelProps {
  match: any
  serviceLevels: IMap<IProviderServiceLevel>
  fetchServiceLevels: () => Promise<any>
}
export default class ServiceLevelPane extends React.Component<IServiceLevelProps> {
  public componentDidMount() {
    this.props.fetchServiceLevels()
  }
  public render() {
    const listItems = Object.values(this.props.serviceLevels).map(i => ({ label: i.name, id: i.id }))
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddServiceLevelModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveServiceLevelModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditServiceLevelModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Service Level</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/service-level/create'
            >
              <Plus className='svg-white mr1' />
              Add Service Level
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Service Level List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={listItems} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceLevelPane.tsx